export default __webpack_public_path__ + "_/images/app/ios/ios-en-2-0b55c92a8e1800671d876f6d5a6d5c36b9c5172e487fe2cfd66f1f1f7fbc164e.png";